import { render } from "./reminderPanel.vue?vue&type=template&id=7eacc9ed&scoped=true"
import script from "./reminderPanel.vue?vue&type=script&lang=js"
export * from "./reminderPanel.vue?vue&type=script&lang=js"

import "./reminderPanel.vue?vue&type=style&index=0&id=7eacc9ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eacc9ed"]])

export default __exports__